import {
  GROUP_TYPES,
  EXTERNAL_GROUP_TYPES,
  computeFeaturePermissions,
  isExternalGroupSet
} from '../schemas/defaultGroups';

export { GROUP_TYPES, EXTERNAL_GROUP_TYPES, computeFeaturePermissions, isExternalGroupSet };

export const VAULT_PERMISSIONS = {
  FULL_ACCESS: {
    name: 'Full Access',
    permissions: {
      read: true,
      write: true,
      delete: true,
      upload: true,
      download: true,
      grant: true
    }
  },
  EXTENDED_ACCESS: {
    name: 'Extended Access',
    permissions: {
      read: true,
      write: true,
      upload: true,
      download: true,
      delete: false,
      grant: false
    }
  },
  BASIC_ACCESS: {
    name: 'Basic Access',
    permissions: {
      read: true,
      write: true,
      upload: true,
      download: true,
      delete: false,
      grant: false
    }
  },
  READ_ONLY: {
    name: 'Read Only',
    permissions: {
      read: true,
      write: false,
      upload: false,
      download: true,
      delete: false,
      grant: false
    }
  }
};

export const PORTAL_PERMISSIONS = {
  ADMIN: {
    name: 'Admin',
    permissions: {
      view: true,
      write: true,
      change: true,
      delete: true,
      customize: true
    }
  },
  MODERATOR: {
    name: 'Moderator',
    permissions: {
      view: true,
      write: true,
      change: true,
      delete: true,
      customize: false
    }
  },
  CONTRIBUTOR: {
    name: 'Contributor',
    permissions: {
      view: true,
      write: true,
      change: 'own',
      delete: 'own',
      customize: false
    }
  },
  VIEWER: {
    name: 'Viewer',
    permissions: {
      view: true,
      write: false,
      change: false,
      delete: false,
      customize: false
    }
  }
};

export const DEFAULT_PERMISSIONS = {
  'Immediate Family': {
    vault: VAULT_PERMISSIONS.FULL_ACCESS,
    portal: PORTAL_PERMISSIONS.ADMIN
  },
  'Elders': {
    vault: VAULT_PERMISSIONS.READ_ONLY,
    portal: PORTAL_PERMISSIONS.MODERATOR
  },
  'Extended Family': {
    vault: VAULT_PERMISSIONS.EXTENDED_ACCESS,
    portal: PORTAL_PERMISSIONS.CONTRIBUTOR
  },
  'Parents Siblings': {
    vault: VAULT_PERMISSIONS.BASIC_ACCESS,
    portal: PORTAL_PERMISSIONS.CONTRIBUTOR
  },
  'Sibling Children': {
    vault: VAULT_PERMISSIONS.BASIC_ACCESS,
    portal: PORTAL_PERMISSIONS.CONTRIBUTOR
  },
  'Distant Family': {
    vault: VAULT_PERMISSIONS.READ_ONLY,
    portal: PORTAL_PERMISSIONS.VIEWER
  }
};

